import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import { CampaignReduced } from '../../models';
import { useTranslations } from '../../store/translations/hooks';
import { TK } from '../../store/translations/translationKeys';
import AppButton from '../../components/AppButton';

export interface CampaignDeleteOrArchiveModalProps {
    campaign?: CampaignReduced;
    action: 'delete' | 'archive';
    isOpen: boolean;
    loading: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

export const CampaignDeleteOrArchiveModal: React.FC<CampaignDeleteOrArchiveModalProps> = ({
    campaign,
    action,
    isOpen,
    loading,
    onConfirm,
    onClose,
}) => {
    const t = useTranslations();

    return (
        <Modal isOpen={isOpen} toggle={onClose}>
            <ModalHeader toggle={onClose}>
                {action === 'archive' ? t(TK.archiveCampaign) : t(TK.delete)}
            </ModalHeader>
            <ModalBody>
                {action === 'archive'
                    ? t(TK.confirmArchiveCampaignBody)
                    : t(TK.youRAboutToDelete)}
                {campaign?.name ? <div style={{ marginTop: 'var(--spacer-S)', fontWeight: 700 }}>{campaign.name}</div> : null}
            </ModalBody>
            <ModalFooter>
                <AppButton color={action === 'archive' ? 'warning' : 'danger'} onClick={onConfirm} disabled={loading}>
                    {loading ? <Spinner size="sm" /> : action === 'archive' ? t(TK.archiveCampaign) : t(TK.delete)}
                </AppButton>
                <AppButton color="secondary" onClick={onClose} disabled={loading}>
                    {t(TK.cancel)}
                </AppButton>
            </ModalFooter>
        </Modal>
    );
}
